import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';

const colorMap = {
  light: {
    indigo: { bg: '#eef2ff', color: '#4f46e5' },
    emerald: { bg: '#ecfdf5', color: '#059669' },
    blue: { bg: '#eff6ff', color: '#2563eb' },
    amber: { bg: '#fffbeb', color: '#d97706' },
    rose: { bg: '#fff1f2', color: '#e11d48' },
    slate: { bg: '#f8fafc', color: '#64748b' },
  },
  dark: {
    indigo: { bg: 'rgba(99,102,241,0.12)', color: '#818cf8' },
    emerald: { bg: 'rgba(16,185,129,0.12)', color: '#34d399' },
    blue: { bg: 'rgba(59,130,246,0.12)', color: '#60a5fa' },
    amber: { bg: 'rgba(245,158,11,0.12)', color: '#fbbf24' },
    rose: { bg: 'rgba(244,63,94,0.12)', color: '#fb7185' },
    slate: { bg: 'rgba(255,255,255,0.06)', color: '#94a3b8' },
  },
};

function StatCard({ icon, value, label, accent, active }) {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';
  const palette = isDark ? colorMap.dark : colorMap.light;
  const colors = palette[accent] || palette.slate;

  return (
    <div style={{
      backgroundColor: isDark ? '#2a2a2e' : '#fff',
      borderRadius: '12px',
      border: active
        ? `2px solid ${colors.color}`
        : `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#e2e8f0'}`,
      padding: active ? '15px' : '16px',
      boxShadow: active ? `0 0 0 1px ${colors.color}22` : (isDark ? 'none' : '0 1px 2px 0 rgba(0,0,0,0.05)'),
      transition: 'all 0.15s ease',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div style={{
          width: '40px',
          height: '40px',
          borderRadius: '10px',
          backgroundColor: colors.bg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: colors.color,
          flexShrink: 0,
        }}>
          {icon}
        </div>
        <div>
          <div style={{
            fontSize: '24px',
            fontWeight: 700,
            color: isDark ? '#e2e8f0' : '#0f172a',
            lineHeight: 1.2,
          }}>
            {typeof value === 'number' ? value.toLocaleString() : value}
          </div>
          <div style={{
            fontSize: '12px',
            color: isDark ? '#64748b' : '#94a3b8',
            marginTop: '2px',
            whiteSpace: 'nowrap',
          }}>
            {label}
          </div>
        </div>
      </div>
    </div>
  );
}

StatCard.propTypes = {
  icon: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  label: PropTypes.string.isRequired,
  accent: PropTypes.oneOf(['indigo', 'emerald', 'blue', 'amber', 'rose', 'slate']),
};

StatCard.defaultProps = {
  accent: 'slate',
};

export default StatCard;
